<template>
  <div class="container-xxl business-page py-5">
    <div class="container">
      <div class="business-hero">
        <div>
          <h6 class="section-title text-start text-primary text-uppercase">Firmalarımız</h6>
          <h1>Ankara'daki Ağrılı firmalar, esnaflar ve güvenilir hizmetler</h1>
          <p>
            Ankara'da Ağrılı esnaf, firma ve hizmet arayan hemşehrilerimiz için
            güvenilir işletmeleri tek listede topluyoruz. Vize danışmanlığı,
            inşaat, sigorta, hukuk, restoran, dekorasyon ve daha birçok alanda
            doğrudan firma sahipleriyle iletişim kurabilirsiniz.
          </p>
        </div>
        <div class="business-summary">
          <span>{{ FIRMALAR.length }}</span>
          <strong>Kayıtlı firma</strong>
          <small>Esnaf, hizmet ve danışmanlık ağı</small>
        </div>
      </div>

      <div class="business-toolbar">
        <div class="business-search">
          <i class="fa fa-search"></i>
          <input
            v-model.trim="searchTerm"
            type="search"
            placeholder="Firma, kategori, kişi veya adres ara"
            aria-label="Firmalarda ara"
          >
        </div>
        <a :href="whatsappJoinUrl" target="_blank" rel="noopener" class="btn btn-primary">
          <i class="fab fa-whatsapp me-2"></i>Firmanı Ekle
        </a>
      </div>

      <div class="business-seo-strip">
        <span>Ankara Ağrılı firmalar</span>
        <span>Ağrılı esnaflar Ankara</span>
        <span>Hemşehri işletmeleri</span>
        <span>Güvenilir hizmet ağı</span>
      </div>

      <div class="business-layout">
        <aside class="business-note">
          <i class="fa fa-store"></i>
          <h2>Müşteri ve firma buluşması</h2>
          <p>
            Bu sayfa Ankara'da müşteri arayan Ağrılı firmaların görünürlüğünü artırmak,
            hizmet arayan hemşehrilerimizin ise doğru kişiye hızlı ulaşmasını sağlamak için hazırlanmıştır.
          </p>
          <div class="business-note-meta">
            <span><i class="fa fa-phone-alt"></i> Tek dokunuşla arama</span>
            <span><i class="fab fa-whatsapp"></i> WhatsApp mesajı</span>
            <span><i class="fa fa-map-marker-alt"></i> Konum bağlantısı</span>
            <span><i class="fa fa-tags"></i> Kategori bilgisi</span>
          </div>
        </aside>

        <div class="business-list">
          <article
            v-for="(item, index) in filteredFirmalar"
            :key="item.title"
            class="business-row"
          >
            <div class="business-index">{{ String(index + 1).padStart(2, '0') }}</div>

            <div class="business-content">
              <div class="business-row-head">
                <div>
                  <h2>{{ item.title }}</h2>
                  <p>{{ getExcerpt(item.desciption) }}</p>
                </div>

                <div class="business-categories">
                  <span v-for="cat in getCategories(item.category)" :key="cat">{{ cat }}</span>
                </div>
              </div>

              <div class="business-info-grid">
                <div>
                  <i class="fa fa-user"></i>
                  <span>{{ item.contact }}</span>
                </div>
                <div>
                  <i class="fa fa-map-marker-alt"></i>
                  <span>{{ item.adress }}</span>
                </div>
                <a :href="`tel:${normalizePhone(item.phone)}`">
                  <i class="fa fa-phone-alt"></i>
                  <span>{{ item.phone }}</span>
                </a>
              </div>

              <div class="business-actions">
                <a class="btn btn-primary" :href="`tel:${normalizePhone(item.phone)}`">
                  <i class="fa fa-phone-alt me-2"></i>Ara
                </a>

                <a
                  v-if="hasWhatsapp(item.phone)"
                  class="btn btn-success"
                  :href="getWhatsappUrl(item)"
                  target="_blank"
                  rel="noopener"
                >
                  <i class="fab fa-whatsapp me-2"></i>WhatsApp
                </a>

                <a class="btn btn-outline-dark" :href="item.location" target="_blank" rel="noopener">
                  <i class="fa fa-map-marker-alt me-2"></i>Konum
                </a>

                <router-link class="btn btn-dark" :to="`/firma/${slugify(item.title)}`">
                  Detay
                </router-link>

                <button type="button" class="btn btn-download-png" @click="downloadAsPng(item)">
                  <i class="fa fa-download me-2"></i>PNG İndir
                </button>
              </div>
            </div>
          </article>

          <div v-if="filteredFirmalar.length === 0" class="business-empty">
            <i class="fa fa-search"></i>
            <h2>Sonuç bulunamadı</h2>
            <p>Arama metnini değiştirerek tekrar deneyebilirsiniz.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="business-poster-capture-wrapper" aria-hidden="true">
      <div
        v-for="item in filteredFirmalar"
        :key="`poster-${item.title}`"
        :ref="(el) => setPosterRef(item, el)"
        class="business-poster"
      >
        <div class="poster-bg-circle poster-bg-circle-one"></div>
        <div class="poster-bg-circle poster-bg-circle-two"></div>

        <header class="poster-header">
          <div class="poster-logo">
            <img src="/img/logo.jpg" alt="Ankara Ağrılılar Derneği">
          </div>
          <div>
            <span>Ankara Ağrılılar Derneği</span>
            <strong>Firma ve Esnaf Rehberi</strong>
          </div>
        </header>

        <main class="poster-main">
          <div class="poster-label">
            <i class="fa fa-store"></i>
            Güvenilir Hizmet Ağı
          </div>

          <h2>{{ item.title }}</h2>
          <div class="poster-title-line"></div>

          <p>{{ getPosterDescription(item.desciption) }}</p>

          <div class="poster-tags">
            <span v-for="cat in getCategories(item.category).slice(0, 4)" :key="cat">
              {{ cat }}
            </span>
          </div>

          <div class="poster-info-card">
            <div>
              <i class="fa fa-user"></i>
              <small>YETKİLİ</small>
              <strong>{{ item.contact }}</strong>
            </div>

            <div>
              <i class="fa fa-phone"></i>
              <small>TELEFON</small>
              <strong>{{ item.phone }}</strong>
            </div>

            <div>
              <i class="fa fa-map-marker-alt"></i>
              <small>ADRES</small>
              <strong>{{ item.adress }}</strong>
            </div>
          </div>
        </main>

        <footer class="poster-footer">
          <i class="fa fa-users"></i>
          <div>
            <strong>Ankara'daki Ağrılı firmalar tek platformda</strong>
            <span>Hemşehrilerimiz için firma, esnaf ve güvenilir hizmet ağı</span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import html2canvas from 'html2canvas';
import FIRMALAR from '@/data/firmalar';
import slugify from '@/utils';

const searchTerm = ref('');
const posterRefs = ref({});

const whatsappJoinUrl = `https://wa.me/905079217404?text=${encodeURIComponent('Derneğinize websitesinden katıldım, firmamı dernek sitesine ekletmek istiyorum.')}`;

const filteredFirmalar = computed(() => {
  const term = searchTerm.value.toLocaleLowerCase('tr-TR');

  if (!term) return FIRMALAR;

  return FIRMALAR.filter((item) => {
    return [
      item.title,
      item.desciption,
      item.adress,
      item.contact,
      item.phone,
      item.category
    ].join(' ').toLocaleLowerCase('tr-TR').includes(term);
  });
});

function setPosterRef(item, el) {
  if (!el) return;
  posterRefs.value[slugify(item.title)] = el;
}

async function downloadAsPng(item) {
  const element = posterRefs.value[slugify(item.title)];
  if (!element) return;

  try {
    const canvas = await html2canvas(element, {
      backgroundColor: '#fffdf8',
      scale: 2,
      useCORS: true,
      width: 1080,
      height: 1350,
      windowWidth: 1080,
      windowHeight: 1350
    });

    const link = document.createElement('a');
    link.download = `${slugify(item.title)}-firma-tanitimi.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  } catch (error) {
    console.error('PNG oluşturulamadı:', error);
    alert('PNG oluşturulamadı. Lütfen tekrar deneyin.');
  }
}

function getCategories(category) {
  if (!category) return [];
  return category.split(',').map((item) => item.trim()).filter(Boolean);
}

function normalizePhone(phone) {
  return String(phone || '').replace(/\s/g, '');
}

function normalizeWhatsappPhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.startsWith('90')) return digits;
  if (digits.startsWith('0')) return `90${digits.slice(1)}`;
  return `90${digits}`;
}

function hasWhatsapp(phone) {
  return normalizePhone(phone).replace(/\D/g, '').replace(/^90/, '').replace(/^0/, '').startsWith('5');
}

function getWhatsappUrl(item) {
  const message = `Merhaba, Ankara Ağrılılar Derneği web sitesinde ${item.title} firmanızı gördüm. Hizmetleriniz hakkında bilgi almak istiyorum.`;
  return `https://wa.me/${normalizeWhatsappPhone(item.phone)}?text=${encodeURIComponent(message)}`;
}

function getExcerpt(text) {
  const cleanText = String(text || '').replace(/\s+/g, ' ').trim();
  if (cleanText.length <= 220) return cleanText;
  return `${cleanText.slice(0, 220)}...`;
}

function getPosterDescription(text) {
  const cleanText = String(text || '').replace(/\s+/g, ' ').trim();
  if (cleanText.length <= 210) return cleanText;
  return `${cleanText.slice(0, 210)}...`;
}
</script>

<style scoped>
.business-page {
  background: linear-gradient(180deg, #FFFFFF 0%, #F7FAFC 48%, #FFFFFF 100%);
}

.business-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 230px;
  gap: 32px;
  align-items: end;
  margin-bottom: 28px;
}

.business-hero h1 {
  color: var(--dark);
  font-size: clamp(32px, 4vw, 52px);
  line-height: 1.08;
  max-width: 900px;
  margin: 0 0 18px;
}

.business-hero p {
  color: #5B6475;
  font-size: 18px;
  line-height: 1.7;
  max-width: 820px;
  margin: 0;
}

.business-summary {
  background: var(--dark);
  color: #FFFFFF;
  min-height: 190px;
  padding: 26px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px;
  box-shadow: 0 18px 38px rgba(15, 23, 43, .14);
}

.business-summary span {
  color: var(--primary);
  font-size: 58px;
  font-weight: 800;
  line-height: 1;
}

.business-summary strong {
  font-size: 20px;
  margin-top: 10px;
}

.business-summary small {
  color: rgba(255, 255, 255, .76);
  margin-top: 8px;
}

.business-toolbar {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}

.business-search {
  flex: 1;
  min-height: 56px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .1);
  border-radius: 8px;
  padding: 0 18px;
  box-shadow: 0 10px 26px rgba(15, 23, 43, .06);
}

.business-search i {
  color: var(--primary);
}

.business-search input {
  width: 100%;
  border: 0;
  outline: 0;
  color: var(--dark);
  background: transparent;
  font-size: 16px;
}

.business-seo-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 28px;
}

.business-seo-strip span {
  color: #344054;
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-left: 3px solid var(--primary);
  border-radius: 999px;
  font-size: 13px;
  font-weight: 800;
  padding: 8px 12px;
}

.business-layout {
  display: grid;
  grid-template-columns: 310px minmax(0, 1fr);
  gap: 28px;
  align-items: start;
}

.business-note {
  position: sticky;
  top: 118px;
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 14px 35px rgba(15, 23, 43, .08);
}

.business-note > i {
  color: var(--primary);
  font-size: 34px;
  margin-bottom: 18px;
}

.business-note h2,
.business-empty h2 {
  color: var(--dark);
  font-size: 24px;
  margin-bottom: 12px;
}

.business-note p,
.business-empty p {
  color: #606A7A;
  line-height: 1.7;
}

.business-note-meta {
  display: grid;
  gap: 10px;
  margin-top: 18px;
}

.business-note-meta span {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #344054;
  font-weight: 600;
}

.business-note-meta i {
  color: var(--primary);
  width: 18px;
}

.business-list {
  display: grid;
  gap: 14px;
}

.business-row {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 18px;
  background: #FFFFFF;
  border: 1px solid rgba(15, 23, 43, .08);
  border-left: 4px solid var(--primary);
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 10px 28px rgba(15, 23, 43, .06);
}

.business-index {
  width: 46px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #FFF4DF;
  color: var(--primary);
  font-weight: 800;
  border-radius: 50%;
}

.business-content {
  min-width: 0;
}

.business-row-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 18px;
  align-items: start;
}

.business-row-head h2 {
  color: var(--dark);
  font-size: 23px;
  margin: 0 0 8px;
}

.business-row-head p {
  color: #5F6979;
  line-height: 1.65;
  margin: 0;
}

.business-categories {
  max-width: 260px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 7px;
}

.business-categories span {
  color: #7A4C00;
  background: #FFF4DF;
  border: 1px solid #FFE2AA;
  font-size: 12px;
  font-weight: 700;
  padding: 7px 9px;
  border-radius: 999px;
}

.business-info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 18px 0;
}

.business-info-grid div,
.business-info-grid a {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  color: #465166;
  background: #F8FAFC;
  border: 1px solid rgba(15, 23, 43, .06);
  border-radius: 8px;
  padding: 12px;
  min-width: 0;
}

.business-info-grid a:hover {
  color: var(--dark);
  border-color: rgba(254, 161, 22, .35);
  background: #FFF9EF;
}

.business-info-grid i {
  color: var(--primary);
  margin-top: 4px;
}

.business-info-grid span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.business-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.business-actions .btn,
.business-toolbar .btn {
  min-height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 10px 18px;
}

.btn-download-png {
  color: #FFFFFF;
  background: #0F766E;
  border: 1px solid #0F766E;
}

.btn-download-png:hover {
  color: #FFFFFF;
  background: #115E59;
  border-color: #115E59;
}

.business-empty {
  background: #FFFFFF;
  border: 1px dashed rgba(15, 23, 43, .18);
  border-radius: 8px;
  padding: 34px;
  text-align: center;
}

.business-empty i {
  color: var(--primary);
  font-size: 34px;
  margin-bottom: 16px;
}

.business-poster-capture-wrapper {
  position: fixed;
  left: -20000px;
  top: 0;
  width: 1080px;
  height: 1350px;
  overflow: hidden;
  pointer-events: none;
  opacity: 1;
}

.business-poster {
  position: relative;
  width: 1080px;
  height: 1350px;
  overflow: hidden;
  color: var(--dark);
  background:
    radial-gradient(circle at top right, rgba(254, 161, 22, .22), transparent 34%),
    linear-gradient(180deg, #fffdf8 0%, #ffffff 48%, #fff7ea 100%);
  font-family: Arial, sans-serif;
  padding: 54px;
  border: 2px solid rgba(254, 161, 22, .55);
  border-radius: 36px;
}

.poster-bg-circle {
  position: absolute;
  pointer-events: none;
  border-radius: 50%;
}

.poster-bg-circle-one {
  width: 520px;
  height: 520px;
  right: -210px;
  top: -180px;
  border: 72px solid rgba(254, 161, 22, .12);
}

.poster-bg-circle-two {
  width: 420px;
  height: 420px;
  left: -220px;
  bottom: 120px;
  background: radial-gradient(circle, rgba(15, 23, 43, .07), rgba(15, 23, 43, 0) 70%);
}

.poster-header,
.poster-main,
.poster-footer {
  position: relative;
  z-index: 2;
}

.poster-header {
  min-height: 150px;
  display: flex;
  align-items: center;
  gap: 28px;
  background: #0F172B;
  color: #FFFFFF;
  border-radius: 22px;
  padding: 26px 32px;
  box-shadow: 0 22px 54px rgba(15, 23, 43, .18);
}

.poster-logo {
  width: 96px;
  height: 96px;
  flex: 0 0 96px;
  background: #FFFFFF;
  border-radius: 50%;
  padding: 6px;
}

.poster-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}

.poster-header span {
  display: block;
  color: rgba(255, 255, 255, .78);
  font-size: 31px;
  font-weight: 800;
  line-height: 1.15;
}

.poster-header strong {
  display: block;
  color: #FFFFFF;
  font-size: 48px;
  font-weight: 900;
  line-height: 1.1;
  margin-top: 6px;
}

.poster-main {
  margin-top: 44px;
}

.poster-label {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: #7A4C00;
  background: #FFF0D1;
  border: 2px solid #FFE0A3;
  border-radius: 999px;
  font-size: 27px;
  font-weight: 900;
  padding: 14px 24px;
}

.poster-label i {
  color: var(--primary);
}

.poster-main h2 {
  color: var(--dark);
  font-size: 72px;
  font-weight: 900;
  line-height: 1.05;
  letter-spacing: -1.5px;
  margin: 34px 0 18px;
}

.poster-title-line {
  width: 210px;
  height: 5px;
  background: var(--primary);
  border-radius: 999px;
  margin-bottom: 24px;
}

.poster-main p {
  color: #4B5563;
  font-size: 31px;
  font-weight: 700;
  line-height: 1.42;
  margin: 0;
}

.poster-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 28px;
}

.poster-tags span {
  color: #7A4C00;
  background: #FFFFFF;
  border: 2px solid #FFE2AA;
  border-radius: 999px;
  font-size: 22px;
  font-weight: 900;
  padding: 10px 18px;
}

.poster-info-card {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
  background: #FFFFFF;
  border: 2px solid rgba(15, 23, 43, .08);
  border-left: 12px solid var(--primary);
  border-radius: 22px;
  margin-top: 32px;
  padding: 18px 28px;
  box-shadow: 0 28px 70px rgba(15, 23, 43, .1);
}

.poster-info-card div {
  display: grid;
  grid-template-columns: 54px 150px minmax(0, 1fr);
  align-items: center;
  gap: 18px;
  min-height: 68px;
}

.poster-info-card div + div {
  border-top: 1px solid rgba(15, 23, 43, .18);
}

.poster-info-card i {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #0F172B;
  color: #FFFFFF;
  border-radius: 8px;
  font-size: 22px;
}

.poster-info-card small {
  color: #6B7280;
  font-size: 22px;
  font-weight: 900;
  text-transform: uppercase;
}

.poster-info-card strong {
  color: var(--dark);
  font-size: 26px;
  font-weight: 900;
  line-height: 1.22;
  overflow-wrap: anywhere;
}

.poster-footer {
  position: absolute;
  left: 64px;
  right: 64px;
  bottom: 44px;
  display: flex;
  align-items: center;
  gap: 22px;
}

.poster-footer i {
  color: var(--primary);
  font-size: 46px;
  width: 54px;
  text-align: center;
}

.poster-footer strong {
  display: block;
  color: var(--dark);
  font-size: 28px;
  font-weight: 900;
  line-height: 1.2;
}

.poster-footer span {
  display: block;
  color: #6B7280;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
  margin-top: 4px;
}

@media (max-width: 991.98px) {
  .business-hero,
  .business-layout {
    grid-template-columns: 1fr;
  }

  .business-summary {
    min-height: auto;
  }

  .business-note {
    position: static;
  }

  .business-row-head,
  .business-info-grid {
    grid-template-columns: 1fr;
  }

  .business-categories {
    max-width: none;
    justify-content: flex-start;
  }
}

@media (max-width: 575.98px) {
  .business-page {
    padding-bottom: 86px !important;
  }

  .business-hero h1 {
    font-size: 32px;
  }

  .business-hero p {
    font-size: 16px;
  }

  .business-toolbar {
    align-items: stretch;
    flex-direction: column;
  }

  .business-toolbar .btn,
  .business-actions .btn {
    width: 100%;
  }

  .business-row {
    grid-template-columns: 1fr;
    padding: 16px;
  }

  .business-index {
    width: 40px;
    height: 40px;
  }

  .business-row-head h2 {
    font-size: 20px;
  }
}
</style>